var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIInformationFill = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66683 10.834H8.16683V10.334V6.33398V5.83398H7.66683H6.3335H5.8335V6.33398V10.334V10.834H6.3335H7.66683ZM7.66683 5.50065H8.16683V5.00065V3.66732V3.16732H7.66683H6.3335H5.8335V3.66732V5.00065V5.50065H6.3335H7.66683ZM0.833496 7.00065C0.833496 3.59479 3.59431 0.833984 7.00016 0.833984C10.406 0.833984 13.1668 3.59479 13.1668 7.00065C13.1668 10.4065 10.406 13.1673 7.00016 13.1673C3.59431 13.1673 0.833496 10.4065 0.833496 7.00065Z",
    fill: "#1C2024",
    stroke: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIInformationFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_information_fill.d00e8467.svg";
export { ForwardRef as ReactComponent };